import React from 'react';

interface IExclamationTriangle {
  className?: string;
}

export default function ExclamationTriangle({ className }: IExclamationTriangle) {
  return (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
      <path d="M248.7 204.7l6.6 112c.4 6.3 5.6 11.3 12 11.3h41.4a12 12 0 0 0 12-11.3l6.6-112c.4-6.9-5.1-12.7-12-12.7h-54.5c-6.9 0-12.4 5.8-12 12.7zM330 384c0 23.2-18.8 42-42 42s-42-18.8-42-42 18.8-42 42-42 42 18.8 42 42zm-.4-360c-18.4-32-64.7-32-83.2 0L6.5 440C-11.9 471.9 11.1 512 48.1 512H527.9c36.9 0 60-40 41.6-72L329.6 24zM53.2 455L282.8 57c2.3-4 8.1-4 10.4 0l229.6 398c2.3 4-.6 9-5.2 9H58.4c-4.6 0-7.5-5-5.2-9z" />
    </svg>
  );
}
